import Template from './selector.vue';
import i18n from '@/i18n'
import router from '@/router'

let globalOptions = {
    show: false,
    closable: true,
    error: false,
    params: [],
    actions: [],
    expanded: false,
    callBackSave: function(){},
    callBackEdit: function(){},
    callBackRemove: function(){},
    callBackClose: function( self ){
        self.$comboSelector.close();
    }
};

let instance;

const Close = function (config = {}) {
    if( instance !== undefined ){
        instance.$data.show = false
        document.body.removeChild(instance.$mount().$el)
        instance = undefined
    }
}

const Combo = function(config = {}) {
    let Tpl = this.extend(Template);
    instance = new Tpl();

    config = {
        ...globalOptions,
        ...config
    };
    for(let key in config) {
        if(config.hasOwnProperty(key)) {
            instance.$data[key] = config[key];
        }
    }
    instance.$data.show = true;
    document.body.style.overflow = 'hidden';
    document.body.appendChild(instance.$mount().$el);
}


const Dismiss = () => {
    instance.$data.show = false;
    document.body.style.overflow = 'auto';
}

export default {
    install(Vue) {
        Vue.prototype.$comboSelector = Combo.bind(Vue);
        Vue.prototype.$comboSelector.close = Close.bind(Vue);
    }
}